export default __webpack_public_path__ + "static/media/Shoptaki Data AI 2.fee63827.png";